import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Filter } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const AffectationsFiltersCard = ({
  searchTerm, setSearchTerm,
  departmentFilter, setDepartmentFilter,
  siteFilter, setSiteFilter,
  calendarFilter, setCalendarFilter,
  departments, sites,
}) => {
  const { t } = useTranslation();

  return (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Filter className="h-5 w-5" />
        {t('common.filter')}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label>{t('common.search')}</Label>
          <div className="relative">
            <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder={t('holidayAssignments.filters.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-8"
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label>{t('holidayAssignments.table.department')}</Label>
          <Select value={departmentFilter} onValueChange={setDepartmentFilter}>
            <SelectTrigger><SelectValue placeholder={t('holidayAssignments.filters.allDepartments')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('holidayAssignments.filters.allDepartments')}</SelectItem>
              {departments.map((dept) => (
                <SelectItem key={dept.id} value={dept.id.toString()}>{dept.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t('holidayAssignments.filters.site')}</Label>
          <Select value={siteFilter} onValueChange={setSiteFilter}>
            <SelectTrigger><SelectValue placeholder={t('holidayAssignments.filters.allSites')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('holidayAssignments.filters.allSites')}</SelectItem>
              {sites.map((site) => (
                <SelectItem key={site.id} value={site.id.toString()}>{site.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>{t('holidayAssignments.filters.calendar')}</Label>
          <Select value={calendarFilter} onValueChange={setCalendarFilter}>
            <SelectTrigger><SelectValue placeholder={t('common.all')} /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('common.all')}</SelectItem>
              <SelectItem value="with">{t('holidayAssignments.filters.withCalendar')}</SelectItem>
              <SelectItem value="without">{t('holidayAssignments.filters.withoutCalendar')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default AffectationsFiltersCard;
